import * as t from "react";
import c from "../lib/IconBase.es.js";
import r from "../defs/TextItalic.es.js";
const e = t.forwardRef((o, a) => /* @__PURE__ */ t.createElement(c, { ref: a, ...o, weights: r }));
e.displayName = "TextItalicIcon";
const s = e;
export {
  s as TextItalic,
  e as TextItalicIcon
};
